import { BaseConfig } from './base';

export function createConfig(): BaseConfig {
  // Strip VITE_ prefix from import.meta.env keys
  const env: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(import.meta.env)) {
    if (key.startsWith('VITE_')) {
      env[key.slice(5)] = value;
    } else {
      env[key] = value;
    }
  }
  const config = BaseConfig.safeParse(env);

  if (!config.success) {
    throw new Error(`Couldn't create app config!\n${JSON.stringify(config.error, null, 2)}`);
  }

  return config.data;
}

let configInstance: BaseConfig;
export function config(): BaseConfig {
  if (configInstance) return configInstance;

  configInstance = createConfig();

  return configInstance;
}